import type { VirtualAppointmentTeam } from '../../../services/virtualAppointments';
import type { VirtualAppointmentOverviewQuery } from '../../../services/virtualAppointmentsOverview';
import type { CalendarPractice } from '../appointments/PracticeFilterList';
import type { OverviewSort } from './overviewSort';
import type { OverviewTabConfig } from './overviewTabs';

export interface OverviewFilters {
    team: VirtualAppointmentTeam | null;
    typeCodes: readonly string[];
    includeCustom: boolean;
    practices: readonly CalendarPractice[];
}

export const EMPTY_OVERVIEW_FILTERS: OverviewFilters = {
    team: null,
    typeCodes: [],
    includeCustom: false,
    practices: []
};

export function hasActiveOverviewFilters(filters: OverviewFilters): boolean {
    return (
        filters.team !== null ||
        filters.typeCodes.length > 0 ||
        filters.includeCustom ||
        filters.practices.length > 0
    );
}

// "Custom" widens the type filter (codes OR custom); left off it applies no custom constraint.
export function buildOverviewQuery(
    tab: OverviewTabConfig,
    filters: OverviewFilters,
    search: string,
    sort: OverviewSort
): VirtualAppointmentOverviewQuery {
    return {
        statuses: tab.statuses,
        teams: filters.team ? [filters.team] : [],
        typeCodes: filters.typeCodes,
        ...(filters.includeCustom && { custom: true }),
        practiceIds: filters.practices.map((practice) => practice.id),
        q: search.trim(),
        sort: sort.by,
        ...(sort.by === 'createdAt' && { order: sort.order })
    };
}
